import * as Sentry from "@sentry/nextjs";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://d1482df10d014649ba21fcb5387f022e@sentry.pmberjaya.com//100",
    environment: "next-client-production",
    tracesSampleRate: 1.0,
  });
}
